import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatchOnMount } from '@qwealth/qcore';
import { IUser, selectUserIsInHeadOffice, selectUserPartnerId } from '@qwealth/qdata';
import { RootState } from '../data/store';
import { loadUsers } from '../data/actions/users';

export const useUserList = (): Array<IUser> => {
  const partnerId = useSelector(selectUserPartnerId);
  const { initializedUsers, isLoading, users } = useSelector((state: RootState) => state.users);

  const canViewAllUsers = useSelector(selectUserIsInHeadOffice);

  const [userList, setUserList] = useState<Array<IUser>>([]);

  useEffect(() => {
    if (initializedUsers && canViewAllUsers) {
      setUserList(users);
    } else if (initializedUsers && !canViewAllUsers && partnerId) {
      setUserList(users.filter(user => user.partnerID === partnerId));
    }
  }, [partnerId, canViewAllUsers, users, initializedUsers]);

  useDispatchOnMount(loadUsers, initializedUsers || isLoading ? undefined : {});

  return userList;
};

export const useUserMap = (): Record<string, IUser> => {
  return useUserList().reduce((map, current) => {
    if (current.id) {
      map[current.id] = current;
    }
    return map;
  }, {});
};
